import { string, func, shape } from 'prop-types'
import { forwardRef } from 'react'
import keyPress from '../../../utilities/keyPress.js'

import Icon from '../../icon/index.js'

const IconButton = forwardRef(
  ({ ariaLabel, className, onClick, iconName, iconColor, style = {} }, ref) => (
    <div
      ref={ref}
      aria-label={ariaLabel}
      className={className}
      onClick={onClick}
      onKeyDown={(e) => {
        keyPress(e, () => onClick(e))
      }}
      role="button"
      style={style}
      tabIndex={0}
    >
      <Icon ariaHidden color={iconColor} icon={iconName} />
    </div>
  ),
)

IconButton.propTypes = {
  ariaLabel: string.isRequired,
  className: string.isRequired,
  iconColor: string,
  iconName: string.isRequired,
  onClick: func.isRequired,
  style: shape(),
}

export default IconButton
